import React from 'react';

import styled from '@emotion/styled';
import { Circle, Divider, HStack, Text } from '@chakra-ui/react';

const StackStyled = styled(HStack)`
  margin-bottom: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: 16px;
  }

  hr {
    border-left-width: 0;
    border-bottom-width: 2px;
    border-radius: 2px;
  }
`;

const CircleStyled = styled(Circle)`
  font-size: 14px;
`;

export const Stepper: React.FC<{
  pageNames: (string | undefined)[];
  pagesCount: number;
  currentPage: number;
}> = ({ pageNames, pagesCount, currentPage }) => (
  <StackStyled divider={<Divider orientation="horizontal" />}>
    {new Array(pagesCount).fill(null).map((_, index) => {
      const isNext = index > currentPage;
      const isCurrent = index === currentPage;
      const isPrevious = index < currentPage;
      const pageName = pageNames[index];

      return (
        <>
          <CircleStyled
            key={`Stepper_circle_${pageName || index}`}
            size="24px"
            border="2px solid"
            borderColor={isNext ? 'white' : 'highlight'}
            color={
              (isNext && 'asphalt.2') || (isCurrent && 'highlight') || 'white'
            }
            bg={isPrevious ? 'highlight' : 'white'}
            letterSpacing="-.5px"
            lineHeight="1em"
          >
            {index + 1}
          </CircleStyled>
          {pageName ? (
            <Text
              key={`Stepper_page_title_${pageName || index}`}
              textStyle="stepper"
              whiteSpace="nowrap"
              ml="0.5rem"
              color="GrayText"
              display={{ base: 'none', md: 'block' }}
            >
              {pageName}
            </Text>
          ) : null}
        </>
      );
    })}
  </StackStyled>
);
